namespace advisorop.components.common {

    export class CuRepGroupController {
        public model: Array<domains.IRepFeeGroup>;
        n: number;
        repFeeGroup: domains.IRepFeeGroup;
        isInEditState: number;
        advisorFirm: any;
        companyGroup: domains.ICompanyGroup;
        externalRepGroupObject: domains.IRepFeeGroup;
        repFeeGroupId: number;
        allocation: domains.RepFeeGroupAllocation = new domains.RepFeeGroupAllocation();
        dgAllocationAdvisorSettings: DevExpress.ui.dxDataGridOptions;
        selectedAdvisor: domains.IAdvisor = null;
        availableFeePercentage = 1;
        adv: domains.IAdvisor = {};
        user: domains.identity.IUser = {};
        laddaOperationInProgress: boolean = false;

        static $inject = ["advisorService", "identityService", "repGroupApi"];
        constructor(
            private advisorService: services.AdvisorService,
            private identityService: services.IdentityService,
            private repGroupApi: services.RepGroupApi) {
            this.repFeeGroup = {
                allocations: []
            };

            this.allocation.percentage = this.availableFeePercentage;

            this.dgAllocationAdvisorSettings = {
                export: {
                    enabled: true,
                    fileName: "RepFeeGroupAllocations"
                },
                bindingOptions: {
                    dataSource: "vm.repFeeGroup.allocations",
                    //,"columns[0].lookup.dataSource": "vm.investmentModels"
                    "columns[2].visible": "!vm.repFeeGroup.noFeesPermissionOnly"
                    //"columns[3].visible": "!vm.repFeeGroup.noFeesPermissionOnly"
                },
                //height: "350px",
                paging: { pageSize: 10 },
                editing: {
                    mode: "cell",
                    allowUpdating: true
                },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                noDataText: "No allocated advisors for this rep group",
      
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: "Search..."
                },
           
                columns: [
                    { dataField: "advisor.fullName", caption: "Advisor", visible: true },
                    { dataField: "advisor.repNumber", caption: "Rep Number", visible: true, width: 100 },                    
                    { dataField: "percentage", caption: "Percentage", format: { type: "percent", precision: 2 }, visible: true, width: 100 },
                    //{ dataField: "houseSplit", caption: "House Split", format: { type: "percent", precision: 2 }, visible: true, width: 100 },
                    { dataField: "id", caption: "#", cellTemplate: "btnActions", width:35 }
                ],
                onRowClick: function (evt) {
                }
            };
        }

    

        newAdvisorSelected(advisor: domains.IAdvisor): void {
            this.selectedAdvisor = advisor;
            this.allocation.houseSplit = advisor.defaultHouseSplit;

        };

        decrementAvailablePercentage(percentage: number) {

            this.availableFeePercentage = this.availableFeePercentage - percentage;

            if (this.availableFeePercentage < 0)
                this.availableFeePercentage = 0;
            else if (this.availableFeePercentage > 1)
                this.availableFeePercentage = 1;
        };


        addAdvisorAllocation(): void {
            if (!this.selectedAdvisor || !(this.selectedAdvisor.id > 0)) {

                toastr.error("Please select advisor.");

                return;
            }

            if (this.repFeeGroup.allocations.filter((v) => {
                return v.advisorId == this.selectedAdvisor.id;
            }).length > 0) {
                toastr.warning("Advisor is already contained by this group, please select another advisor");
                return;
            }

            if (this.allocation.percentage < 0 || this.allocation.percentage > 1) {
                toastr.error("Percentage must be greeater then 0% and less then 100%");
                return;
            }

            if (this.allocation.houseSplit < 0 || this.allocation.houseSplit > 1) {
                toastr.error("Housesplit must be greeater then 0% and less then 100%");
                return;
            }

            this.allocation.advisor = {};

            angular.copy(this.selectedAdvisor, this.allocation.advisor);

            this.allocation.advisorId = this.selectedAdvisor.id;

            this.allocation.repFeeGroupId = this.repFeeGroup.id;

            if (this.availableFeePercentage - this.allocation.percentage < 0)
            {
                toastr.warning("Total percentage cannot be greater then 100%");
                return;
            }

            this.decrementAvailablePercentage(this.allocation.percentage);
            
            var tmpAllocation: domains.RepFeeGroupAllocation = new domains.RepFeeGroupAllocation();

            angular.copy(this.allocation, tmpAllocation);

            // ADD TO ALLOCATIONS
            this.repFeeGroup.allocations.push(tmpAllocation);

            this.allocation = new domains.RepFeeGroupAllocation();
            this.allocation.percentage = this.availableFeePercentage;
            //this.allocation.houseSplit = this.adv.defaultHouseSplit;
       
            this.selectedAdvisor = null;
        };

        removeAdvisorFromAllocationList(allocation: domains.IRepFeeGroupAllocation): void {
            var ind = this.repFeeGroup.allocations.indexOf(allocation);

            if (ind >= 0) {
                this.decrementAvailablePercentage(-this.repFeeGroup.allocations[ind].percentage);                
                this.allocation.percentage = this.availableFeePercentage;
                this.repFeeGroup.allocations.splice(ind, 1);
            }
        };

        onCreatedGroup: any;
        disableButtonAfterPost: boolean = false;
        //Create Rep Fee Group
        createRepFeeGroup(): void {

            if (this.repFeeGroup.name == null || this.repFeeGroup.name.replace(/\s/g, '').length < 1)
            {
                toastr.warning("Please enter valid name for Rep Group.");
                return;
            }

            if (this.repFeeGroup.allocations.length < 1) {
                toastr.warning("Please add advisor to allocation.");
                return;
            }

            this.repFeeGroup.id = 0;

            this.repGroupApi.create(this.repFeeGroup)
                .then((data) => {
                    this.laddaOperationInProgress = true;
                    toastr.success("Group successfully added.");
                    this.repFeeGroup = data.data;
                    this.onCreatedGroup({ event: this.repFeeGroup });

                    //this.repFeeGroup.allocations = [];
                }).catch((error) => {
                    toastr.error("Error " + error);
                    return;
                })
                .finally(() => {
                    this.laddaOperationInProgress = false;

                    this.repFeeGroup = {
                        allocations: []
                    };

                    this.availableFeePercentage = 1;
                    this.allocation.percentage = this.availableFeePercentage;
                    this.stateCreateRepFee = false;
                });
        };

        //Update Rep Fee Group
        updateRepFeeGroup(repFeeGroup: domains.IRepFeeGroup): void {
            this.repGroupApi.update(repFeeGroup)
                    .then((data) => {
                        this.laddaOperationInProgress = true;
                        toastr.success("Group has been successfully updated.");
                        this.repFeeGroup = data.data;
                        this.onCreatedGroup({ event: this.repFeeGroup });
                    })
                    .catch((error) => {
                        toastr.error("Error " + error);
                        return;
                    })
                    .finally(() => {
                        this.laddaOperationInProgress = false;

                        this.repFeeGroup = {
                            allocations: []
                        };

                        this.availableFeePercentage = 1;
                        this.allocation.percentage = this.availableFeePercentage;
                        this.stateCreateRepFee = false;
                    });
        };

        ////Get Rep Fee Group By Id
        repGroupId: number;
        getRepFeeGroupById(repFeeGroupId: number): void {

            this.repGroupId = repFeeGroupId;
            this.isInEditState = 1;
            this.availableFeePercentage = 1;
            this.repGroupApi.getById(repFeeGroupId)
                    .then(data => {
                        this.repFeeGroup = data.data;
                        var sumOfPercents: number = 0;
                        for (var i = 0; i <= this.repFeeGroup.allocations.length - 1; i++) {
                            sumOfPercents = sumOfPercents + this.repFeeGroup.allocations[i].percentage;
                        }
                        this.decrementAvailablePercentage(sumOfPercents);
                        this.allocation.percentage = this.availableFeePercentage;
                    }).
                    catch(error => {
                        toastr.error("Can not find this group" + error.status + " " + error.data);
                    })
        };

        cancel(): void {

            this.allocation.houseSplit = this.adv.defaultHouseSplit;

            this.repFeeGroup = { allocations: [] };

            this.selectedAdvisor = null;

            this.availableFeePercentage = 1;

            this.allocation.percentage = this.availableFeePercentage;

            this.onCreatedGroup({ event: this.repFeeGroup = null });
        }

        $onInit() {
            this.identityService.getUserPromise().then(response => {
                this.user = response;
                this.adv = this.user.advisor;
            });
        }

        $routerOnActivate(next, previous) {
            if (next.params.groupId) {
                this.getRepFeeGroupById(<number>next.params.groupId);
            }
        }

        clearAllEntries(): void {
            this.allocation.houseSplit = this.adv.defaultHouseSplit;

            this.repFeeGroup = { allocations: [] };

            this.selectedAdvisor = null;

            this.availableFeePercentage = 1;

            this.allocation.percentage = this.availableFeePercentage;
        }
        stateCreateRepFee: boolean = false;

        $onChanges(evt): void {
            for (var key in evt) {
                if (key === "externalRepGroupObject") {
                    if (this.externalRepGroupObject && this.externalRepGroupObject.id > 0) {
                        this.getRepFeeGroupById(this.externalRepGroupObject.id);
                    }
                    else if (!this.externalRepGroupObject || this.externalRepGroupObject.id <= 0) {
                        this.clearAllEntries();
                    }
                }
                if (key === "isInEditState" && this.isInEditState == 1 && this.repFeeGroupId > 0) {
                    this.stateCreateRepFee = !this.stateCreateRepFee;
                    this.getRepFeeGroupById(this.repFeeGroupId);
                }
            }
        }
    }

    class CuRepGroup implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                advisor: "<",
                isInEditState: "<",
                onCreatedGroup: "&",
                //repFeeGroupId: "<",
                externalRepGroupObject: "<"
            };
            this.controller = CuRepGroupController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/shared/common/cu-rep-group.html";
        }
    }
    angular.module(Constants.APP).component("cuRepGroup", new CuRepGroup());
}